import Dashboard from '@/views/Dashboard/Index.vue'

export default [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            title: 'common.dashboard.title',
            menuRendered: true,
            menuTitle: 'common.dashboard.menuTitle',
            requiresAuth: true,
            icon: 'mdi-view-dashboard'
        }
    }
]
